import { MaxBrainAudience } from '../models/audience.model';

export class AddAudiences {
    static readonly type = '[Audience] AddAudiences';

    constructor(public payload: MaxBrainAudience[]) {}
}
